import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Products } from "@/components/site/Products";
import { Wood } from "@/components/site/Wood";
import { Footer } from "@/components/site/Footer";
import { Delivery } from "@/components/site/Delivery";
import { Shop } from "@/components/site/Shop";
import { Reviews } from "@/components/site/Reviews";
import { CartDrawer } from "@/components/site/CartDrawer";
import { CartProvider } from "@/components/site/cart";
import { Toaster } from "@/components/ui/sonner";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, anchors: true });
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <CartProvider>
    <div className="App bg-[#1A110C]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <Shop />
        <Reviews />
        <Delivery />
        <Wood />
      </main>
      <Footer />
      <WhatsAppButton />
      <CartDrawer />
      <Toaster position="top-center" />
    </div>
    </CartProvider>
  );
}

export default App;
